module.exports = __webpack_public_path__ + "img/envelopamento4.c6039cff.jpg";